import { render } from "./paid-coffee-actions.vue?vue&type=template&id=f6ad069e&lang=pug"
import script from "./paid-coffee-actions.vue?vue&type=script&lang=js"
export * from "./paid-coffee-actions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__